const fonts = {
  body: "'Helvetica Neue', sans-serif",
  heading: "'Georgia', serif",
};

export default fonts;
